import i18n from '@dms/i18n';

import {Field} from './primitives/Field';

export function BatteryCertificateCheckbox() {
  return (
    <Field
      type="checkbox"
      name="batteryCertificate"
      label={i18n.t('entity.vehicle.labels.batteryCertificate')}
    />
  );
}
